/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationAnalyticsShowQueryParams,
	OrganisationAnalyticsShowResponse,
} from '../types/OrganisationAnalyticsShow'

/**
 * GET /analytics/overview
 * @see backend/nexus/modules/Analytics/Http/Controllers/OrganisationAnalyticsController.php OrganisationAnalyticsController::show
 */
export async function organisationAnalyticsShow(
	params?: OrganisationAnalyticsShowQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationAnalyticsShowResponse>> {
	return axiosInstance.get('/analytics/overview', { params, ...config })
}
